import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import Dom from './Dom';

class Polyfills {

    static addPolyfills(callback) {
        let numberOfScripts = 2;

        if (typeof Promise == 'undefined') {
            Dom.addScript('//cdn.jsdelivr.net/bluebird/3.5.0/bluebird.min.js', () => { 
                numberOfScripts--;
                if (numberOfScripts == 0) {
                    callback();
                }
            });
        } else {
            numberOfScripts--;
        }

        //fix to use fetch polyfill in old versions of chrome:
        //https://github.com/github/fetch/issues/470
        var versionNumber = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        if (versionNumber && parseInt(versionNumber[2], 10) < 69) window.fetch = undefined;

        if (typeof fetch == 'undefined') {
            Dom.addScript('https://cdnjs.cloudflare.com/ajax/libs/fetch/2.0.3/fetch.min.js', () => { 
                numberOfScripts--;
                if (numberOfScripts == 0) {
                    callback();
                }
            });
        } else {
            numberOfScripts--;
        }

        if (numberOfScripts == 0) {
            callback();
        }
    }
}

export default Polyfills;